import cookie from "react-cookies";
import Bugsnag from "@bugsnag/js";

/**
 * Google Ads Click ID parameters to track
 * - gclid: Google Click Identifier (standard Google Ads)
 * - gbraid: App attribution for iOS (Privacy Sandbox)
 * - wbraid: Web attribution for iOS (Privacy Sandbox)
 */
const GOOGLE_CLICK_PARAMS = ["gclid", "gbraid", "wbraid"];

/**
 * Parse and store Google Ads click IDs from URL
 * Should be called on app initialization
 */
function captureGoogleClickIds() {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    
    for (const param of GOOGLE_CLICK_PARAMS) {
      const value = urlParams.get(param);
      if (value) {
        // Store the click ID with a 90-day expiry (Google's attribution window)
        cookie.save(`qt_${param}`, value, {
          path: "/",
          maxAge: 7776000, // 90 days in seconds
          secure: true,
          sameSite: "lax",
        });
        console.log(`[GoogleAds] Captured ${param}:`, value.substring(0, 10) + "...");
      }
    }
  } catch (error) {
    Bugsnag.notify(error);
  }
}

/**
 * Get the stored Google Ads click ID
 * Priority: gclid > gbraid > wbraid
 * Returns object with type and value
 */
function getGoogleClickId() {
  try {
    for (const param of GOOGLE_CLICK_PARAMS) {
      const value = cookie.load(`qt_${param}`);
      if (value) {
        return { type: param, value };
      }
    }
  } catch (error) {
    Bugsnag.notify(error);
  }
  return null;
}

/**
 * Get all Google Ads click IDs as an object
 * Returns { gclid: "...", gbraid: "...", wbraid: "..." }
 */
function getAllGoogleClickIds() {
  try {
    const clickIds = {};
    for (const param of GOOGLE_CLICK_PARAMS) {
      const value = cookie.load(`qt_${param}`);
      if (value) {
        clickIds[param] = value;
      }
    }
    return clickIds;
  } catch (error) {
    Bugsnag.notify(error);
    return {};
  }
}

function navigator_() {
  try {
    var _navigator = {};
    for (var i in window.navigator) _navigator[i] = navigator[i];
    delete _navigator.plugins;
    delete _navigator.mimeTypes;
    return JSON.stringify(_navigator) + " <<navigator>> ";
  } catch (error) {
    Bugsnag.notify(error);
    return "";
  }
}
function source_() {
  try {
    return (
      (cookie.load("source_") || "") + " <<url>> NOLOCATOIN,NOLOCATOIN"
      // (cookie.load("locationsource_") || "")
    );
  } catch (error) {
    Bugsnag.notify(error);
    return "";
  }
}
const navs = {
  navigator_,
  source_,
  captureGoogleClickIds,
  getGoogleClickId,
  getAllGoogleClickIds,
};

export default navs;
